<template>
    <div>
            <div class="category_box">
                <div class="category_cont">
                    <div class="category">
                        <div class="category_title">
                            <div class="section_title">
                                <div class="section_title_cont text-left">
                                    <h3>KATEGÓRIÁK</h3>
                                </div>
                            </div>
                        </div>
                        <div class="category_lists_box">
                            <div class="category_box">
                                <div class="category_box_cont">
                                     <!-- egyelőre csak 2 submenut támogat, később rekurzívra át kell írni, egy csak most gyorsan hogy meglegyen -->
                                    <ul>
                                        <li v-for="c in categories" :class="{active: selectedCategory.id == c.id}">
                                            <i class="fa fa-angle-right" aria-hidden="true"></i>
                                            <a @click="setSelectedCategory(c)" data-toggle="collapse" :data-target="'#'+c.id">{{c.name}}</a>
                                            <ul v-if="c.children != undefined" class="collapse" :class="{in : (childIsActive(c) || c.id == selectedCategory.id)}" :id="c.id">
                                                <li v-for="cc in c.children" :class="{active: selectedCategory.id == cc.id}">
                                                    <i class="fa fa-angle-right" aria-hidden="true"></i>
                                                    <a @click="setSelectedCategory(cc)">{{cc.name}}</a>
                                                    <!-- <ul v-if="cc.children != undefined">
                                                        <li v-for="ccc in cc.children" :class="{active: selectedCategory.id == ccc.id}">
                                                            <i class="fa fa-angle-right" aria-hidden="true"></i>
                                                            <a @click="setSelectedCategory(ccc)">{{ccc.name}}</a>
                                                        </li>
                                                    </ul> -->
                                                </li>
                                            </ul>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <template v-if="propertyGroups != null">
                <div class="category_box" v-for="pg in propertyGroups">
                    <div class="category_cont">
                        <div class="category">
                            <div class="category_title">
                                <div class="section_title">
                                    <div class="section_title_cont text-left">
                                        <h3>{{pg.name}}</h3>
                                    </div>
                                </div>
                            </div>
                            <div class="category_lists_box" v-if="pg.type == 'DEFINED'">
                                <div class="category_box">

                                    <div class="danger_chq_box" v-for="pc in pg.propertyCounts">
                                        <div>
                                            <input :id="'checkbox-'+pc.property.id" class="checkbox-custom" type="checkbox" v-model="pc.selected" @change="filterChanged">
                                            <label :for="'checkbox-'+pc.property.id" class="checkbox-custom-label">{{pc.property.name}} ({{pc.count}})</label>
                                        </div>
                                    </div>

                                </div>
                            </div>

                            <div class="category_lists_box" v-if="pg.type=='VALUE'">
                                <div class="category_box">
                                    <div class="price-range">
                                        <div class="min_max_box">
                                            <b class="pull-left">Min.</b> <b class="pull-right">Max.</b>
                                        </div>

                                        <div class="well text-center">

                                            <div class="slider slider-horizontal" style="width: 174px;">
                                                <div class="slider-track">
                                                    <div class="slider-selection" ></div>
                                                    <div class="slider-handle round left-round" ></div>
                                                    <div class="slider-handle round right-round"></div>
                                                </div>
                                                <div class="tooltip top" style="top: -30px; left: 24.875px;">
                                                    <div class="tooltip-arrow"></div>
                                                    <div class="tooltip-inner">10 : 365</div>
                                                </div>
                                                <input type="text" class="span2" value="" data-slider-min="0" data-slider-max="600" data-slider-step="5" data-slider-value="[250,450]" id="sl2" style="">
                                            </div><br>
                                            <b class="pull-left">10 ft</b> <b class="pull-right">450 ft</b>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>

            </template>

        </div>
</template>

<script>
import Endpoints from '@commons/communication/endpoints.js'

export default{
    mixins:[Endpoints],
    props: ['propertyGroups','sc'],
    data:function () {
        return {
            categories:[],
            selectedCategory:this.sc
        };
    },
    // watch: {
    //     sc:function (sc) {
    //         console.log('sc changed: '+JSON.stringify(sc));
    //         this.selectedCategory = sc;
    //     }
    // },
    created:function () {
        var self = this;
        // this.selectedCategory = {id:1};
        this.connGetCategoryTree(function (r) {
            self.categories = r.data.list[0].children;
        })
    },
    mounted:function () {
        $('.slider').slider();
    },
    methods:{
        filterChanged:function () {
            var pgs = [];

            for (var i = 0; i < this.propertyGroups.length; i++) {
                var pg = this.propertyGroups[i];
                if (pg.type=='DEFINED'){
                    var o = {
                        propertyGroupId : pg.id,
                        andFilterBetweenElements: pg.andFilterBetweenElements,
                        properties: []
                    }
                    for (var j = 0; j < pg.propertyCounts.length; j++) {
                        var pc = pg.propertyCounts[j];
                        if (pc.selected){
                            o.properties.push(pc.property.id)
                        }
                    }
                    if (o.properties.length > 0){
                        pgs.push(o);
                    }
                }else if (pg.type == 'VALUE'){
                    //TODO
                }
            }

            var o = {
                categoryId:this.selectedCategory.id,
                propertyGroups:pgs
            }

            this.$emit('filterChanged', o);
        },
        setSelectedCategory(cat){
            this.selectedCategory = cat;
            var o = {
                categoryId:this.selectedCategory.id,
            }

            this.$emit('filterChanged', o);
        },
        childIsActive(cat){

            if (cat.children != undefined){
                for (var i = 0; i < cat.children.length; i++) {
                    var c = cat.children[i];
                    if (c.id == this.selectedCategory.id){
                        return true;
                    }
                }
            }
            return false;
        }

    }
}
</script>

<style>
.category_box_cont ul li{
    margin-bottom: 0px;
    padding-top: 5px;
    padding-bottom: 5px;
    padding-left: 25px;
    padding-right: 15px;
}
.danger_chq_box{
    padding-top: 5px;
    padding-bottom: 5px;
    padding-right: 15px;
    padding-left: 20px;
}
</style>



// WEBPACK FOOTER //
// Filter.vue?26cf25a6